import { render, staticRenderFns } from "./portfolio4.vue?vue&type=template&id=43e65a5c&"
import script from "./portfolio4.vue?vue&type=script&lang=js&"
export * from "./portfolio4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports